import React from 'react';

export const GridBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none">
      <div 
        className="absolute inset-0 bg-grid-pattern" 
        style={{ backgroundSize: '40px 40px' }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian via-transparent to-obsidian"></div>
    </div>
  );
};